<div class="kanban-column-tile" [style.border-color]="kanbanColumn.htmlColor">
  <div *ngFor="let kanbanControl of kanbanControls" class="kanban-control">
    <span *ngIf="kanbanControl.label" class="kanban-control-label"> {{ kanbanControl.label }}: </span>

    <span class="kanban-control-value">
      {{ record | kanbanControlValue: kanbanControl }}
    </span>
  </div>
</div>
